import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiCrud } from '@lib/models/api';
import { Notification } from '@lib/models';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService extends BaseApiCrud<Notification> {
  override resourcePath = 'notifications';
  override classType = Notification;

  constructor(public override http: HttpClient) {
    super(environment, http);
  }

  getUnreadCount(): Observable<number> {
    return this.http.get<number>(this.getResourceUrl('count'));
  }

  markAsRead(id: number): Observable<Notification> {
    return this.http.put<Notification>(this.getResourceUrl(`${id}/read`), {});
  }

  markAllRead(): Observable<void> {
    return this.http.put<void>(this.url, {});
  }

  deleteAll(): Observable<void> {
    return this.http.delete<void>(this.url);
  }
}
